import * as React from 'react';
import { PlayerItemView, UserAchievementInfo } from '../../../generated/protocol';
import { AppCtx } from '../../ioc/ApplicationContext';
import { Symbols } from '../../ioc/Symbols';
import { AchievementsService } from '../../service/achievements/AchievementsService';
import { DeleteButtonModal } from '../util/DeleteButtonModal';

interface Props {
    info: UserAchievementInfo;
}

interface State {
    items: PlayerItemView[]
}

export class UserItems extends React.Component<Props, State> {
    achievementService: AchievementsService;

    constructor(props) {
        super(props);
        this.achievementService = AppCtx.resolve<AchievementsService>(Symbols.AchievementsService);
        this.state = {items: this.props.info.items.items};
    }

    getItems() {
        return this.state.items.map(item => {
            return (
                <tr key={item.id}>
                    <td><img src={item.imageUrl} className='' alt='icon' height='32'/></td>
                    <td>{item.name}</td>
                    <td>{item.expires}</td>
                    <td className='text-navy'>
                        {item.equipped ? <i className='fa fa-star' /> : ''}
                    </td>
                    <td className='text-navy'>
                        {item.isFree ? <i className='fa fa-star' /> : ''}
                    </td>
                    <td>
                        <DeleteButtonModal label='Remove' className='btn-sm btn-danger'
                                           onDelete={() => this.deleteItem(item)}
                                           description={item.nameId} />
                    </td>
                </tr>
            );
        });
    }

    deleteItem(item: PlayerItemView): Promise<void> {
        return this.achievementService
            .deleteUserItem(item.player, item.id)
            .then(() => {
                const newItems = this.state.items.filter(filterItem =>  filterItem.id !== item.id);
                this.setState({items: newItems});
            });
    }

    render() {
        return (
            <div className='col-sm-12'>
                <div className='ibox float-e-margins'>
                    <div className='ibox-title'>
                        <h2>Items</h2>
                    </div>

                    <div className='ibox-content'>
                        <table className='table table-hover'>
                            <thead>
                            <tr>
                                <th>Icon</th>
                                <th>Name</th>
                                <th>Expires (ms)</th>
                                <th>Equipped</th>
                                <th>Free giveaway</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.getItems()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/user/UserItems.tsx